// read this articel 
// https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#adding-custom-environment-variables
export default function DEBUG() {  
  return process.env.NODE_ENV !== "production"
}


// WEBPACK FOOTER //
// ./src/App/config/debug.js